// src/pages/Dashboard/Finance/Payroll/PharmacyReport.jsx
import React from "react";
import { Grid, Paper, Box, Typography } from "@mui/material";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import { useTranslation } from "react-i18next";

const PharmacyReport = ({
  medicineSalesData = {},
  prescriptionData = {},
  echoData = {},
  purchaseData = {},
}) => {
  const { t } = useTranslation();
  const data = [
    {
      name: t("finance.medicineSales"),
      Total: Number(medicineSalesData.total_medicine_sales) || 0,
      Unpaid: Number(medicineSalesData.unpaid_medicine_sales) || 0,
    },
    {
      name: t("finance.prescriptionSales"),
      Total: Number(prescriptionData.total_prescription_sales) || 0,
      Unpaid: Number(prescriptionData.unpaid_prescription_sales) || 0,
    },
    {
      name: t("finance.echoRevenue"),
      Total: Number(echoData.total_echo_revenue) || 0,
      Unpaid: Number(echoData.unpaid_echo_amount) || 0,
    },
    {
      name: t("finance.purchaseExpenses"),
      Total: Number(purchaseData.total_purchase_expenses) || 0,
      Unapproved: Number(purchaseData.unapproved_purchase_expenses) || 0,
    },
  ];

  return (
    <Grid container>
      <Paper sx={{ width: "100%", padding: 3, borderRadius: 2, boxShadow: 3 }}>
        <Box textAlign="center" mb={2}>
          <Typography variant="h5" fontWeight="bold" color="primary">
            {t("finance.pharmacyPurchases")}
          </Typography>
        </Box>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" strokeOpacity={0.3} />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="Total" fill="#1976d2" barSize={30} name={t("finance.total")} />
            <Bar dataKey="Unpaid" fill="#ff8a65" barSize={30} name={t("finance.unpaid")} />
            <Bar dataKey="Unapproved" fill="#d32f2f" barSize={30} name={t("finance.unapproved")} />
          </BarChart>
        </ResponsiveContainer>
      </Paper>
    </Grid>
  );
};

export default PharmacyReport;
